export const isChromatic = (): boolean => {
  if (typeof window === "undefined") {
    return false;
  }
  return Boolean(/Chromatic/.test(window.navigator.userAgent) || /chromatic=true/.test(window.location.href));
};
